import { useEffect, useRef, useState } from 'react'
import { Button, Modal, message } from 'antd'
import axios from 'axios'
import http from '../../utils/api'
import './BoothManagement2.less'

const DeleteBoothParticipant = ({
  visible,
  handleCancel,
  boothName,
  fundName,
  participantName,
  boothParticipantId,
  setLoading,
  closeModal,
}) => {
  const handleParticipantDelete = () => {
    http
      .post(
        '/booths/fundParticipant/' +
          boothParticipantId +
          '/cancel?api-version=2'
      )
      .then(function (response) {
        setLoading()
        message.success('Participant is removed successfully !', 3)
      })
      .catch(function (error) {
        message.error('An error has occurred!', 3)
      })
      .finally(() => {
        closeModal()
      })
  }

  return (
    <Modal
      visible={visible}
      width="350px"
      bodyStyle={{ padding: 0 }}
      onCancel={() => {
        handleCancel()
      }}
      footer={[
        <Button
          onClick={() => {
            handleCancel()
          }}
          className="cancelBtn"
        >
          Cancel
        </Button>,

        <Button
          visible={false}
          type="primary"
          onClick={() => handleParticipantDelete()}
          style={{ cursor: 'pointer', backgroundColor: '#D62B34' }}
        >
          Remove
        </Button>,
      ]}
    >
      <div style={{ padding: '13px 16px 32px 32px' }}>
        <div style={{ display: 'flex' }}>
          <div style={{}}>
            <div style={{ marginTop: '40px' }} className="cc-heading">
              Are you sure you want to remove <b> {participantName} </b> from
              <b> {fundName} </b>
              on <b> {boothName} </b> ?
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteBoothParticipant
